import React from 'react';
import { Vehicle } from 'core/models/vehicle';
import { SteeringIndicator as SteeringIndicatorView } from 'components/views/molecules/SteeringIndicator';
import { useVehicleStatus } from 'services/useVehicleStatus';
import { Project } from 'core/models/project';

export type SteeringIndicatorProps = {
    className?: string;
    vehicleId: Vehicle.Id;
    projectId: Project.Id;
};

export const SteeringIndicator = (props: SteeringIndicatorProps) => {
    const vehicleStatus = useVehicleStatus(props.vehicleId, props.projectId);

    const angle = vehicleStatus.steering * 360;
    return (
        <SteeringIndicatorView className={props.className} angle={angle} />
    );
};
